export default __webpack_public_path__ + "2c37f6116c6ea5b379dd0929b9c402a6.png";